import {
  ButtonOK,
  ContentLabel,
  ModalBody,
  ModalOverlay,
  Title,
} from "../styles";
import { useIntl } from "react-intl";

const ModalNotification = ({
  isOpen,
  title = undefined,
  message = undefined,
  onClose,
  printedCredential = false,
  IconPrinted = undefined,
  IconWarning = undefined,
  backgroundColor = "#fff",
  textColor = "#000",
  bgButtonOk = "#2c3e50",
  textButtonOk = "#ffffff",
}) => {
  const intl = useIntl();

  return (
    <ModalOverlay
      printedCredential={printedCredential}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      backgroundColor={backgroundColor}
      textColor={textColor}
    >
      <ModalBody printedCredential={printedCredential}>
        {printedCredential && IconPrinted && (
          <div style={{ marginBottom: "50px" }}>
            <IconPrinted />
          </div>
        )}

        {!printedCredential && IconWarning && (
          <div style={{ marginBottom: "50px" }}>
            <IconWarning />
          </div>
        )}

        {title && <Title textColor={textColor}>{title}</Title>}

        {message && (
          <ContentLabel textColor={textColor}>{message}</ContentLabel>
        )}

        <ButtonOK
          bgButtonOk={bgButtonOk}
          textButtonOk={textButtonOk}
          onClick={onClose}
        >
          OK
        </ButtonOK>
      </ModalBody>
    </ModalOverlay>
  );
};

export default ModalNotification;
